// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "utf-8";

.bottombar-homepage {
  z-index: 100;
  min-height: 40px;
  padding: 0px 0px;
  width: 100%;
  background-color: #ffffff;
  font-weight: 400;
  font-size: 16px;
  visibility: visible;
  align-content: center;
  text-align: center;
}

.buzzbeat-footer {
  background-color: #fff;
  color: #000;
  padding: 20px 0px 0px 0px;
  font-size: 14px;
}


.buzzbeat-footer p {
  background-color: #fff;
  color: #000;
  padding: 20px 0;
  font-size: 14px;
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 5px; 
	margin: 5px 25px 5px 25px;
	justify-content: center; /* Centers the content horizontally */
  align-items: center; 
}


.footer-section {
 	justify-content: center;
  align-items: center; 
	margin-bottom: 5px;
}


.footer-section h4 {
  margin-bottom: 15px;
}


.footer-section ul li {
  display: inline-block;
  margin-right: 20px; /* Adjust the space between items as needed */
}


.footer-section ul li a {
  color: #0028FF;
  text-decoration: none;
  transition: color 0.3s ease;
	font-weight: 300;
	letter-spacing: 0.05em;
	border: 1px solid #ffffff;
	padding: 3px 6px 3px 6px;
}

.footer-section ul li a:hover {
  color: #0028FF;
border: 1px solid #0028FF;
	padding: 3px 6px 3px 6px;
}
`, "",{"version":3,"sources":["webpack://./src/BuzzBeatFooterPage.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAEhB;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;;AAGA;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;CACT,yBAAyB;CACzB,uBAAuB,EAAE,qCAAqC;EAC7D,mBAAmB;AACrB;;;AAGA;EACE,uBAAuB;EACvB,mBAAmB;CACpB,kBAAkB;AACnB;;;AAGA;EACE,mBAAmB;AACrB;;;AAGA;EACE,qBAAqB;EACrB,kBAAkB,EAAE,6CAA6C;AACnE;;;AAGA;EACE,cAAc;EACd,qBAAqB;EACrB,2BAA2B;CAC5B,gBAAgB;CAChB,sBAAsB;CACtB,yBAAyB;CACzB,wBAAwB;AACzB;;AAEA;EACE,cAAc;AAChB,yBAAyB;CACxB,wBAAwB;AACzB","sourcesContent":["@charset \"utf-8\";\n\n.bottombar-homepage {\n  z-index: 100;\n  min-height: 40px;\n  padding: 0px 0px;\n  width: 100%;\n  background-color: #ffffff;\n  font-weight: 400;\n  font-size: 16px;\n  visibility: visible;\n  align-content: center;\n  text-align: center;\n}\n\n.buzzbeat-footer {\n  background-color: #fff;\n  color: #000;\n  padding: 20px 0px 0px 0px;\n  font-size: 14px;\n}\n\n\n.buzzbeat-footer p {\n  background-color: #fff;\n  color: #000;\n  padding: 20px 0;\n  font-size: 14px;\n}\n\n.footer-content {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 5px; \n\tmargin: 5px 25px 5px 25px;\n\tjustify-content: center; /* Centers the content horizontally */\n  align-items: center; \n}\n\n\n.footer-section {\n \tjustify-content: center;\n  align-items: center; \n\tmargin-bottom: 5px;\n}\n\n\n.footer-section h4 {\n  margin-bottom: 15px;\n}\n\n\n.footer-section ul li {\n  display: inline-block;\n  margin-right: 20px; /* Adjust the space between items as needed */\n}\n\n\n.footer-section ul li a {\n  color: #0028FF;\n  text-decoration: none;\n  transition: color 0.3s ease;\n\tfont-weight: 300;\n\tletter-spacing: 0.05em;\n\tborder: 1px solid #ffffff;\n\tpadding: 3px 6px 3px 6px;\n}\n\n.footer-section ul li a:hover {\n  color: #0028FF;\nborder: 1px solid #0028FF;\n\tpadding: 3px 6px 3px 6px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
